import { Drawer, IconButton } from "@mui/material";
import Loader from "../loader";
import { Suspense, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDirect } from "../../hooks";
import keyNames from "../../keyName";
import CloseIcon from "@mui/icons-material/Close";

import uploadImage from "../upload/uploadImage";
import UploadImageFile from "../upload/uploadImage";
const CustomDrawer = () => {
  const directDispatch = useDirect();
  const stateData = useSelector((state) => state.mainReducer);
  const { drawerData, extra } = stateData;

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      directDispatch(null, keyNames.drawerData);
    }, 400);
  };
  useEffect(() => {
    if (!drawerData) {
      setOpen(false);
      return;
    }

    setOpen(drawerData?.showDrawer);
  }, [drawerData]);

  useEffect(() => {
    if (extra?.drawerClose) {
      handleClose();
      directDispatch(null, keyNames.extra);
    }
  }, [extra]);
  return (
    <Drawer
      PaperProps={{
        style: {
          width: "100%",
          maxWidth:
            drawerData?.direction === "top" ||
            drawerData?.direction === "bottom"
              ? null
              : drawerData?.maxWidth ?? "620px",
          maxHeight:
            drawerData?.direction === "left" ||
            drawerData?.direction === "right"
              ? null
              : drawerData?.maxHeight ?? "50vh",
        },
      }}
      anchor={drawerData?.direction ?? "right"}
      open={open}
      onClose={handleClose}
      className={`${drawerData?.className} ${drawerData?.widgetName}`}
      {...drawerData?.drawerProps}
    >
      {drawerData?.closeBtn && (
        <IconButton
          aria-label="close"
          size="large"
          sx={{
            position: "absolute",
            right: 0,
            m: 1,
            color: "#ccc;",
            zIndex: 1501,
          }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      )}
      {drawerData && <UploadImageFile />}
    </Drawer>
  );
};

export default CustomDrawer;
